"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var initialRelatedObjectProps = {
  relatedObject: null,
  relatedObjectError: null
};

var _default = (0, _memoize.default)(function (question, sourceObject, sourceObjectType, enabledAssociations, associations) {
  if (!question || !question.objectType) {
    return initialRelatedObjectProps;
  }

  if (sourceObject && question.objectType === sourceObjectType) {
    return (0, _extends2.default)({}, initialRelatedObjectProps, {
      relatedObject: sourceObject
    });
  }

  if (!enabledAssociations.includes(question.objectType)) {
    return (0, _extends2.default)({}, initialRelatedObjectProps, {
      relatedObjectError: _react.default.createElement(_FormattedMessage.default, {
        message: "composer-plugins.questionAndAnswer.notSupported"
      })
    });
  }

  var association = associations.get(question.objectType, (0, _immutable.Set)()).first();

  if (association) {
    return (0, _extends2.default)({}, initialRelatedObjectProps, {
      relatedObject: association
    });
  }

  return (0, _extends2.default)({}, initialRelatedObjectProps, {
    relatedObjectError: _react.default.createElement(_FormattedMessage.default, {
      message: "composer-plugins.questionAndAnswer.associationNotFound"
    })
  });
});

exports.default = _default;
module.exports = exports.default;